import { render, staticRenderFns } from "./Login_Desktop.vue?vue&type=template&id=66871c8c&scoped=true&"
import script from "./Login_Desktop.vue?vue&type=script&lang=js&"
export * from "./Login_Desktop.vue?vue&type=script&lang=js&"
import style0 from "./Login_Desktop.vue?vue&type=style&index=0&id=66871c8c&prod&lang=css&"
import style1 from "./Login_Desktop.vue?vue&type=style&index=1&id=66871c8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66871c8c",
  null
  
)

export default component.exports